import React from 'react'
import ZusSessionProvider from './ZusSessionProvider'
import ZusAggregatedProfileEmbed from './ZusAggregatedProfileEmbed'
import type { Props } from './types'

/** Design-refresh ZAP tab: the same Zus session + embed with the refreshed shell. */
const ZusAggregatedProfile: React.FC<Props> = props => {
  return (
    <ZusSessionProvider>
      <ZusAggregatedProfileEmbed {...props} refreshChrome />
    </ZusSessionProvider>
  )
}

export default ZusAggregatedProfile
